"use strict";
/**
 * `IaArrangement` -> `IaBeat` -> `IaFilling`
 *
 * `IaArrangement` describes the logic how inner separation elements are distributed throughout the echain links.
 * - single: there is only one pattern for IAs in the configuration
 * - evenOdd: there are 2 layouts, one for even and one for odd numbers
 *
 * `IaBeat` describes the starting point and the interval how IAs are mounted in the Kette
 *
 * `IaFilling` describes the 2D position of an IA inside a Ketteglied
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IaArrangement = void 0;
var IaArrangement;
(function (IaArrangement) {
    IaArrangement["single"] = "single";
    IaArrangement["evenOdd"] = "evenOdd";
    IaArrangement["smartPlastics"] = "smartPlastics";
})(IaArrangement = exports.IaArrangement || (exports.IaArrangement = {}));
//# sourceMappingURL=IaArrangement.js.map